var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-form-wrapper" }, [
    _c("div", { attrs: { id: "filter-container" } }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "filters-top text-center d-block" },
          [
            _c("search-component", {
              staticClass: "search-container mx-auto",
              on: { searchInputChange: _vm.handleSearchInputChange }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "toggle-filters text-uppercase text-dark mt-1",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    _vm.showFilters = !_vm.showFilters
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.showFilters ? "Hide" : "Show") +
                    " Filters \n                    "
                ),
                _c("span", {
                  staticClass: "ml-1 d-inline-block fa",
                  class: {
                    "fa-chevron-down": !_vm.showFilters,
                    "fa-chevron-up": _vm.showFilters
                  }
                })
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.showFilters
          ? _c(
              "div",
              { staticClass: "filters-bottom pt-1" },
              [
                _c("filters-component", {
                  on: { filtersChanged: _vm.handleFiltersChanged }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container", attrs: { id: "shop-container" } },
      [
        _c(
          "header",
          {
            staticClass:
              "d-block d-md-flex align-items-center justify-content-between"
          },
          [
            !_vm.filterSelected
              ? _c("h1", { staticClass: "my-1 text-capitalize" }, [
                  _vm._v("Current Product Availability")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.filterSelected
              ? _c("h1", { staticClass: "my-1 text-capitalize" }, [
                  _vm._v(
                    "Current Availability for " +
                      _vm._s(this.selectedFilters[0])
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pagination-info my-1" }, [
              _vm._v(
                "\n                Showing " +
                  _vm._s(_vm.paginationInfo.to) +
                  " of " +
                  _vm._s(_vm.paginationInfo.total) +
                  " Products\n            "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("order-table-component", {
          attrs: { productGroups: _vm.productGroups }
        }),
        _vm._v(" "),
        _c("div", { attrs: { id: "reload-anchor" } }),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass: "loading text-center py-1",
                staticStyle: { "font-size": "16px" },
                attrs: { id: "loading-indicator" }
              },
              [_vm._m(0)]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "order-container" } },
      [_c("cart-wholesale-component")],
      1
    ),
    _vm._v(" "),
    _vm.updating
      ? _c("div", { attrs: { id: "updating-overlay" } }, [_vm._m(1)])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0 text-muted" }, [
      _vm._v("Loading more products "),
      _c("span", { staticClass: "fa fa-spinner fa-spin ml-1" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "updating-text" }, [
      _vm._v("\n            Updating "),
      _c("span", { staticClass: "d-inline-block fa fa-spinner fa-spin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }